
export const TITULO = {
    ATENCAO: 'TITULO.ATENCAO',
    SUCESSO: 'TITULO.SUCESSO',
    PROBLEMA: 'TITULO.PROBLEMA',
    CONFIRMACAO_EXCLUSAO: 'TITULO.CONFIRMACAO_EXCLUSAO',
    CONFIRMACAO_OPERACAO: 'TITULO.CONFIRMACAO_OPERACAO',
};

export const ALERTA = {
    OPERACAO_PENDENTE: 'ALERTA.OPERACAO_PENDENTE',
    FORMULARIO_VALIDACAO: 'ALERTA.FORMULARIO_VALIDACAO',
};

export const SOLICITACAO = {
    SALVAR_REGISTRO_PARA_IMPORTACAO: 'SOLICITACAO.SALVAR_REGISTRO_PARA_IMPORTACAO',
    PREENCHER_CAMPOS_OBRIGATORIOS: 'SOLICITACAO.PREENCHER_CAMPOS_OBRIGATORIOS',
    SELECIONAR_AGENDA: 'SOLICITACAO.SELECIONAR_AGENDA',
    SELECIONAR_PACIENTE: 'SOLICITACAO.SELECIONAR_PACIENTE',
    SELECIONAR_REGISTRO: 'SOLICITACAO.SELECIONAR_REGISTRO',
};

export const ATENDIMENTO = {
    NAO_COMPARECIMENTO: 'ATENDIMENTO.NAO_COMPARECIMENTO',
}

export const CONFIRMACAO = {
    ANULAR_REGISTRO: 'CONFIRMACAO.ANULAR_REGISTRO',
    EXCLUIR_REGISTRO: 'CONFIRMACAO.EXCLUIR_REGISTRO',
    DESVINCULAR_ATENDIMENTO: 'CONFIRMACAO.DESVINCULAR_ATENDIMENTO',
    AGENDA_SLOTS_REPLICACAO: 'CONFIRMACAO.AGENDA_SLOTS_REPLICACAO',
    FINALIZAR_ATENDIMENTO: 'CONFIRMACAO.FINALIZAR_ATENDIMENTO',
}

export const SUCESSO = {
    SALVAMENTO: 'SUCESSO.SALVAMENTO',
    INSERCAO: 'SUCESSO.INSERCAO',
    EDICAO: 'SUCESSO.EDICAO',
    ATUALIZACAO: 'SUCESSO.ATUALIZACAO',
    INATIVACAO: 'SUCESSO.INATIVACAO',
    REATIVACAO: 'SUCESSO.REATIVACAO',
    EXCLUSAO: 'SUCESSO.EXCLUSAO'
};

export const ERRO = {
    SALVAMENTO: 'ERRO.SALVAMENTO',
    INSERCAO: 'ERRO.INSERCAO',
    CARREGAMENTO: 'ERRO.CARREGAMENTO',
    EDICAO: 'ERRO.EDICAO',
    ATUALIZACAO: 'ERRO.ATUALIZACAO',
    INATIVACAO: 'ERRO.INATIVACAO',
    REATIVACAO: 'ERRO.REATIVACAO'
};

export const DOENCA = {
    SUCESSO: {
        VINCULACAO: 'DOENCA.SUCESSO.VINCULACAO',
        ATUALIZACAO: 'DOENCA.SUCESSO.ATUALIZACAO',
        INATIVACAO: 'DOENCA.SUCESSO.INATIVACAO',
        REATIVACAO: 'DOENCA.SUCESSO.REATIVACAO',
        EXCLUSAO: 'DOENCA.SUCESSO.EXCLUSAO'
    },
    ERRO: {
        VINCULACAO: 'DOENCA.ERRO.VINCULACAO',
        ATUALIZACAO: 'DOENCA.ERRO.ATUALIZACAO',
        INATIVACAO: 'DOENCA.ERRO.INATIVACAO',
        REATIVACAO: 'DOENCA.ERRO.REATIVACAO',
        EXCLUSAO: 'DOENCA.ERRO.EXCLUSAO',
    }
}

export const ARQUIVO = {
    SUCESSO: {
        IMPORTACAO: 'ARQUIVO.SUCESSO.IMPORTACAO'
    },
    ERRO: {
        SELECAO: 'ARQUIVO.ERRO.SELECAO',
        TAMANHO: 'ARQUIVO.ERRO.TAMANHO',
        IMPORTACAO: 'ARQUIVO.ERRO.IMPORTACAO',
    }
}

export const ACOMPANHAMENTO = {
    SUCESSO: {
        INSERCAO: 'ACOMPANHAMENTO.SUCESSO.INSERCAO',
        ATUALIZACAO: 'ACOMPANHAMENTO.SUCESSO.ATUALIZACAO',
        INATIVACAO: 'ACOMPANHAMENTO.SUCESSO.INATIVACAO',
        REATIVACAO: 'ACOMPANHAMENTO.SUCESSO.REATIVACAO',
        EXCLUSAO: 'ACOMPANHAMENTO.SUCESSO.EXCLUSAO',
        EDICAO_EVENTO: 'ACOMPANHAMENTO.SUCESSO.EDICAO_EVENTO'
    },
    ERRO: {
        INSERCAO: 'ACOMPANHAMENTO.ERRO.INSERCAO',
        ATUALIZACAO: 'ACOMPANHAMENTO.ERRO.ATUALIZACAO',
        INATIVACAO: 'ACOMPANHAMENTO.ERRO.INATIVACAO',
        REATIVACAO: 'ACOMPANHAMENTO.ERRO.REATIVACAO',
        EXCLUSAO: 'ACOMPANHAMENTO.ERRO.EXCLUSAO',
        EDICAO_EVENTO: 'ACOMPANHAMENTO.ERRO.EDICAO_EVENTO'
    },
    ALERTA: {
        SELECAO: 'ACOMPANHAMENTO.ALERTA.SELECAO'
    },
    SOLICITACAO: {
        PREENCHER_CAMPOS_OBRIGATORIOS: 'ACOMPANHAMENTO.SOLICITACAO.PREENCHER_CAMPOS_OBRIGATORIOS',
        ESPECIALIDADES_OBRIGATORIAS: 'ACOMPANHAMENTO.SOLICITACAO.ESPECIALIDADES_OBRIGATORIAS',
        EXAMES_OBRIGATORIOS: 'ACOMPANHAMENTO.SOLICITACAO.EXAMES_OBRIGATORIOS',
        TRATAMENTOS_OBRIGATORIOS: 'ACOMPANHAMENTO.SOLICITACAO.TRATAMENTOS_OBRIGATORIOS',
        PRESCRICAO_OBRIGATORIA: 'ACOMPANHAMENTO.SOLICITACAO.PRESCRICAO_OBRIGATORIA',
    }
}

export const EVENTO = {
    ACAO: {
        EXCLUSAO: 'EVENTO.ACAO.EXCLUSAO',
        ATUALIZACAO: 'EVENTO.ACAO.ATUALIZACAO'
    },
    SUCESSO: {
        INSERCAO: 'EVENTO.SUCESSO.INSERCAO',
        ATUALIZACAO: 'EVENTO.SUCESSO.ATUALIZACAO',
        INATIVACAO: 'EVENTO.SUCESSO.INATIVACAO',
        REATIVACAO: 'EVENTO.SUCESSO.REATIVACAO',
        EXCLUSAO: 'EVENTO.SUCESSO.EXCLUSAO'
    },
    ERRO: {
        INSERCAO: 'EVENTO.ERRO.INSERCAO',
        ATUALIZACAO: 'EVENTO.ERRO.ATUALIZACAO',
        INATIVACAO: 'EVENTO.ERRO.INATIVACAO',
        REATIVACAO: 'EVENTO.ERRO.REATIVACAO',
        EXCLUSAO: 'EVENTO.ERRO.EXCLUSAO'
    },
    ALERTA: {
        SELECAO: 'EVENTO.ALERTA.SELECAO'
    }
}

export const HISTORICO = {
    ACAO: {
        EXCLUSAO: 'HISTORICO.ACAO.EXCLUSAO'
    },
    SUCESSO: {
        INSERCAO: 'HISTORICO.SUCESSO.INSERCAO',
        ATUALIZACAO: 'HISTORICO.SUCESSO.ATUALIZACAO',
        INATIVACAO: 'HISTORICO.SUCESSO.INATIVACAO',
        REATIVACAO: 'HISTORICO.SUCESSO.REATIVACAO',
        EXCLUSAO: 'HISTORICO.SUCESSO.EXCLUSAO'
    },
    ERRO: {
        INSERCAO: 'HISTORICO.ERRO.INSERCAO',
        ATUALIZACAO: 'HISTORICO.ERRO.ATUALIZACAO',
        INATIVACAO: 'HISTORICO.ERRO.INATIVACAO',
        REATIVACAO: 'HISTORICO.ERRO.REATIVACAO',
        EXCLUSAO: 'HISTORICO.ERRO.EXCLUSAO'
    },
    ALERTA: {
        SELECAO: 'HISTORICO.ALERTA.SELECAO'
    }
}



export const AGENDA_EVENTO = {
    SUCESSO: {
        INSERCAO: 'AGENDA_EVENTO.SUCESSO.INSERCAO',
        ATUALIZACAO: 'AGENDA_EVENTO.SUCESSO.ATUALIZACAO',
        EXCLUSAO: 'AGENDA_EVENTO.SUCESSO.EXCLUSAO',
        SALVAMENTO: 'AGENDA_EVENTO.SUCESSO.SALVAMENTO'
    },
    ERRO: {
        INSERCAO: 'AGENDA_EVENTO.ERRO.INSERCAO',
        ATUALIZACAO: 'AGENDA_EVENTO.ERRO.ATUALIZACAO',
        EXCLUSAO: 'AGENDA_EVENTO.ERRO.EXCLUSAO',
        SALVAMENTO: 'AGENDA_EVENTO.ERRO.SALVAMENTO'
    },
    ALERTA: {
        SELECAO: 'AGENDA_EVENTO.ALERTA.SELECAO',
        PACIENTE_CONTATO_AGENDAMENTO_REMOTO: 'AGENDA_EVENTO.ALERTA.PACIENTE_CONTATO_AGENDAMENTO_REMOTO',
    }
}


export const PRESCRICAO = {
    SUCESSO: {
        INSERCAO: 'PRESCRICAO.SUCESSO.INSERCAO',
        ATUALIZACAO: 'PRESCRICAO.SUCESSO.ATUALIZACAO',
        EXCLUSAO: 'PRESCRICAO.SUCESSO.EXCLUSAO',
        SALVAMENTO: 'PRESCRICAO.SUCESSO.SALVAMENTO'
    },
    ERRO: {
        INSERCAO: 'PRESCRICAO.ERRO.INSERCAO',
        ATUALIZACAO: 'PRESCRICAO.ERRO.ATUALIZACAO',
        EXCLUSAO: 'PRESCRICAO.ERRO.EXCLUSAO',
        SALVAMENTO: 'PRESCRICAO.ERRO.SALVAMENTO'
    },
    SOLICITACAO: {
        PREENCHER_CAMPOS_OBRIGATORIOS: 'PRESCRICAO.SOLICITACAO.PREENCHER_CAMPOS_OBRIGATORIOS',
    }
}